import React, { FC } from 'react';
import { ApprovalModalGexFieldsProps } from './ApprovalModalGexFieldsProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import SkappaCompleteSelect from '../SkappaCompleteSelect';
import { getFyNumber } from '../../utils/calculation';
import SSRIcon from '@ingka/ssr-icon';
import checkmark from '@ingka/ssr-icon/paths/checkmark-circle';
import skapaColours from '@ingka/variables/colours-css';

const ApprovalModalGexFields: FC<ApprovalModalGexFieldsProps> = ({
  gex,
  gexDates,
  setGex,
}) => {
  const t = useTranslation();
  return (
    <Stack>
      <Text style={{ fontWeight: '700' }}>{t('ppm.GEX.alignedWithGex')}</Text>
      <Text>
        <span>{t('ppm.GEX.description')}</span>
      </Text>
      <Stack spacing={2} mt={2}>
        {Object.keys(gex)
          .sort((a, b) => getFyNumber(a) - getFyNumber(b))
          .map((fy) => (
            <>
              <SkappaCompleteSelect
                value={gex[fy]}
                label={fy}
                id={`gex-select-${fy}`}
                onChange={(e) => {
                  setGex(fy, e);
                }}
                options={
                  t('ppm.GEX.options') as unknown as { [key: string]: string }
                }
              />
              {gexDates[fy]?.baselineStartDate && (
                <>
                  <Stack
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    gap={2}
                  >
                    <SSRIcon
                      style={{
                        color: skapaColours.colourSemanticPositive,
                      }}
                      paths={checkmark}
                    />
                    <Text>
                      {`${fy} `}
                      {t('ppm.GEX.alignedWithGexStartDate')}{' '}
                      {gexDates[fy].baselineStartDate}
                    </Text>
                  </Stack>
                  <Stack
                    display={'flex'}
                    flexDirection={'row'}
                    alignItems={'center'}
                    gap={2}
                  >
                    <SSRIcon
                      style={{
                        color: skapaColours.colourSemanticPositive,
                      }}
                      paths={checkmark}
                    />
                    <Text>
                      {`${fy} `}
                      {t('ppm.GEX.alignedWithGexOpeningDate')}{' '}
                      {gexDates[fy].baselineOpeningDate}
                    </Text>
                  </Stack>
                </>
              )}
            </>
          ))}
      </Stack>
    </Stack>
  );
};

export default ApprovalModalGexFields;
